module.exports = __webpack_public_path__ + "img/popup-success-1.993aa42b.png";